import { plural } from '@cian/utils';
import { IOffer } from '../../../types/offer';
import { isSuburban } from '../category/isSuburban';

export function getBedroomCount(offer: IOffer): string | undefined {
  if (isSuburban(offer) && offer.bedroomsCount) {
    return `${offer.bedroomsCount} ${plural(offer.bedroomsCount, ['спальня', 'спальни', 'спален'])}`;
  }

  return undefined;
}
